import { render, staticRenderFns } from "./RegisterDialog.vue?vue&type=template&id=9aee2c8a&scoped=true"
import script from "./RegisterDialog.vue?vue&type=script&lang=js"
export * from "./RegisterDialog.vue?vue&type=script&lang=js"
import style0 from "./RegisterDialog.vue?vue&type=style&index=0&id=9aee2c8a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aee2c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9aee2c8a')) {
      api.createRecord('9aee2c8a', component.options)
    } else {
      api.reload('9aee2c8a', component.options)
    }
    module.hot.accept("./RegisterDialog.vue?vue&type=template&id=9aee2c8a&scoped=true", function () {
      api.rerender('9aee2c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/RegisterDialog.vue"
export default component.exports